import {Grid, Typography} from "@mui/material";
import moment from "moment";
import {extensionLabel} from "../../hooks/useAmiExtensions";

const SummaryItem = ({label, value}) => (
  <Grid item xs={6} md={3} lg={1.5}>
    <Typography fontSize={12} color="text.secondary">{label}</Typography>
    <Typography fontSize={14} fontWeight={500}>{value || "-"}</Typography>
  </Grid>
);

export const CampaignSummary = ({campaign, extension}) => {
  return (
    <Grid container spacing={2} sx={{bgcolor: "grey.100", p: 2, borderRadius: 4, m: 0, width: "100%"}}>
      <SummaryItem label="From number" value={campaign.fromNumber}/>
      <SummaryItem label="Extension" value={extensionLabel(extension) || (campaign.extensionId ? "Unknown" : "-")}/>
      <SummaryItem label="Trunk" value={extension ? extension.trunk || "Default" : "-"}/>
      <SummaryItem
        label="Dates"
        value={`${moment(campaign.startDate).format("DD MMM")} – ${moment(campaign.endDate).format("DD MMM YYYY")}`}
      />
      <SummaryItem label="Calling window" value={`${campaign.startTime} – ${campaign.endTime}`}/>
      <SummaryItem label="Max attempts" value={String(campaign.maxAttempts ?? "-")}/>
      <SummaryItem label="Phone numbers" value={String(campaign.totalPhoneNumbers ?? 0)}/>
      <SummaryItem
        label="Created"
        value={campaign.dateCreated ? moment(campaign.dateCreated).format("DD MMM YYYY HH:mm") : "-"}
      />
    </Grid>
  )
}
